import React from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import EvaluationTemplateListTable from './EvaluationTemplateListTable';

export default function EvaluationTemplateList(props) {
    return <EvaluationTemplateListTable fetchUrl={fetchUrl} editUrl={editUrl} summaryUrl={summaryUrl} createUrl={createUrl} deleteUrl={deleteUrl} />;
}

if (document.getElementById('listEvaluationTemplate')) {
    ReactDOM.render(
        <App>
            <EvaluationTemplateList />
        </App>,
        document.getElementById('listEvaluationTemplate'),
    );
}
